import s from '../FilterList.module.scss'
import React from 'react'
import { ApplyFilter, FilterInputData } from '../../../FilterTypes'

type RadioInputProps = {
    applyFilter: ApplyFilter
    isChecked: boolean
    showCount?: boolean
    isDisabled?: boolean
    filterTypeInput: FilterInputData
    count: number
    isHorizontal?: boolean
}

export const RadioInput = ({
    applyFilter,
    isChecked,
    showCount,
    isDisabled,
    filterTypeInput,
    count,
    isHorizontal
}: RadioInputProps): JSX.Element => {
    const { label, value_string } = filterTypeInput

    return (
        <>
            <label
                className={s['root-checkbox']}
                htmlFor={`${value_string}_${isHorizontal ? 'hr' : 'vr'}`}
                aria-label={String(label)}
            >
                <span className={s['checkbox-container']}>
                    <input
                        type="radio"
                        id={`${value_string}_${isHorizontal ? 'hr' : 'vr'}`}
                        disabled={isDisabled}
                        onChange={(event) =>
                            applyFilter(
                                filterTypeInput,
                                event.target.checked,
                                true
                            )
                        }
                        onClick={() => {
                            if (isChecked) {
                                applyFilter(filterTypeInput, false)
                            }
                        }}
                        checked={isChecked}
                        className={s['input-checkbox']}
                    />
                    <span className={s['label-checkbox']}>
                        <span
                            dangerouslySetInnerHTML={{
                                __html: String(label)
                            }}
                        />
                        {showCount && (
                            <span className={s['count']}>({count})</span>
                        )}
                    </span>
                </span>
            </label>
        </>
    )
}
